import { RootMutationTypes } from './types'

const mutations = {
  [RootMutationTypes.SetHost](state, { host }) {
    return state.host = host
  },
  [RootMutationTypes.SetOrigin](state, { origin }) {
    return state.origin = origin
  },
  [RootMutationTypes.SetSettings](state) {
    if (state.origin === 'HITFM') {
      state.settings = {...state.hitfm_settings}
    }
    if (state.origin === 'DFM') {
      state.settings = {...state.dfm_settings}
    }
    if (state.origin === 'MAXIMUM') {
      state.settings = {...state.maximum_settings}
    }
    if (state.origin === 'MONTECARLO') {
      state.settings = {...state.montecarlo_settings}
    }
    if (state.origin === 'RUSRADIO') {
      state.settings = {...state.rr_settings}
    }
    if (state.origin === 'RU') {
      state.settings = {...state.rutv_settings}
    }
  }
}

export { mutations }


